import React from 'react';
import { DELIVERY_SERVICE_FEE_CENTS, SALES_TAX_PERCENT, DELIVERY_TIP_PERCENT } from '../../../global/util';
import '../../../styles/fight/takerProcess/PriceBreakdownCard.scss';

const PriceBreakdownCard = ({
  subtotal,
  isDelivery,
  total,
  overrideTaxPercent,
  overrideTipPercent,
  customFeesCents,
  disclaimer,
  totalLabel = 'Total',
}) => {
  const serviceFeeCents = customFeesCents ?? DELIVERY_SERVICE_FEE_CENTS;
  const taxPercent = overrideTaxPercent ?? SALES_TAX_PERCENT;
  const tipPercent = overrideTipPercent ?? DELIVERY_TIP_PERCENT;

  const taxCents = Math.round(subtotal * taxPercent);
  const tipCents = Math.round(subtotal * tipPercent);

  return (
    <div className={`price-breakdown ${isDelivery ? '' : 'custom-breakdown'}`}>
      <div className='price-portion'>
        <span>Subtotal:</span>
        <span>${(subtotal / 100).toFixed(2)}</span>
      </div>

      {isDelivery ? (
        <>
          <div className='price-portion'>
            <span>Delivery + Service Fee:</span>
            <span>${(serviceFeeCents / 100).toFixed(2)}</span>
          </div>
          <div className='price-portion'>
            <span>Sales Tax ({(taxPercent * 100).toFixed(1)}%):</span>
            <span>${(taxCents / 100).toFixed(2)}</span>
          </div>
          <div className='price-portion'>
            <span>Tip:</span>
            <span>${(tipCents / 100).toFixed(2)}</span>
          </div>
        </>
      ) : (
        <div className='price-portion'>
          <span>Other Fees and Tax:</span>
          <span>${((total - subtotal) / 100).toFixed(2)}</span>
        </div>
      )}

      <div className='price-portion total'>
        <span>
          <b>{totalLabel}:</b>
        </span>
        <span>${(total / 100).toFixed(2)}</span>
      </div>

      {isDelivery && disclaimer && <p className='sales-tax-disclaimer'>{disclaimer}</p>}
    </div>
  );
};

export default PriceBreakdownCard;
